/*============================================================================
# JavaScript Cookie v2.1.4
  https://github.com/js-cookie/js-cookie

  Copyright 2006, 2015 Klaus Hartl & Fagner Brack
  Released under the MIT license
  ==============================================================================*/
  !function(e){var n=!1;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var o=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=o,t}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var o=arguments[e];for(var t in o)n[t]=o[t]}return n}function n(o){function t(n,r,i){var c;if("undefined"!=typeof document){if(arguments.length>1){if("number"==typeof(i=e({path:"/"},t.defaults,i)).expires){var a=new Date;a.setMilliseconds(a.getMilliseconds()+864e5*i.expires),i.expires=a}i.expires=i.expires?i.expires.toUTCString():"";try{c=JSON.stringify(r),/^[\{\[]/.test(c)&&(r=c)}catch(e){}r=o.write?o.write(r,n):encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=(n=(n=encodeURIComponent(String(n))).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent)).replace(/[\(\)]/g,escape);var f="";for(var s in i)i[s]&&(f+="; "+s,!0!==i[s]&&(f+="="+i[s]));return document.cookie=n+"="+r+f}n||(c={});for(var p=document.cookie?document.cookie.split("; "):[],d=/(%[0-9A-Z]{2})+/g,u=0;u<p.length;u++){var l=p[u].split("="),C=l.slice(1).join("=");'"'===C.charAt(0)&&(C=C.slice(1,-1));try{var g=l[0].replace(d,decodeURIComponent);if(C=o.read?o.read(C,g):o(C,g)||C.replace(d,decodeURIComponent),this.json)try{C=JSON.parse(C)}catch(e){}if(n===g){c=C;break}n||(c[g]=C)}catch(e){}}return c}}return t.set=t,t.get=function(e){return t.call(t,e)},t.getJSON=function(){return t.apply({json:!0},[].slice.call(arguments))},t.defaults={},t.remove=function(n,o){t(n,"",e(o,{expires:-1}))},t.withConverter=n,t}return n(function(){})});

var cartShown     = false;
var cartData      = {};
//var suggestions     = {'Fascia':2.2, 'L Trim':2.2, 'T-Clips':5, 'Joist':0.75, 'Starter Clips':25};
var suggestions     = {'Fascia':0.0982, 'L Trim':0.1964, 'T-Clips':5, '50x50':0.75, 'Starter Clips':15, 'Batten':0.2787};
var callToActionMessage = "Please call our sales team on 0208 088 4888 to order";
var callToActionTitle = "Item out of stock";
Shopify.queue       = [];

function getCart() {
  var cart;
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    async: false,
    success: function(data){cart = data;},
    error: Shopify.onCartError
  });
  return cart;
}

function updateCartItem(form_id) {
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    dataType: 'json',
    data: $('#'+form_id).serialize(),
    success: Shopify.onCartAddSuccess,
    error: Shopify.onCartAddError
  });
}

function callToAction()
{
  swal({title:callToActionTitle, text:callToActionMessage, type: "error", showConfirmButton: true});
}

Shopify.onCartAddSuccess = function(data) {
  //console.log(data);
};

Shopify.onCartAddError = function(data) {
  //console.log(data);
};

Shopify.onCartError = function(data) {
  /*console.log('error');
  console.log(data);*/
};

$(document).ready(function(){

  function getRealHeight(element)
  {
    return element.height() + parseInt(element.css('padding-top')) + parseInt(element.css('padding-bottom')) + parseInt(element.css('margin-top')) + parseInt(element.css('padding-bottom')) + parseInt(element.css('border-top-width')) + parseInt(element.css('border-bottom-width'));
  }

  function addItem(form_id) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: $('#'+form_id).serialize(),
      success: Shopify.onSuccess,
      error: Shopify.onError
    });
  }

  
    $('.addtocart').click(function(e) {
      e.preventDefault();
      $(this).prop('disabled', true);
      addItem('add-item-form');
    });
  

  function updateSubtotal(id, quantityElement)
  {
    var subtotal  = 0;
    var area    = 0;

    $.each($('#add' + id + ' .qty'), function(index, element){
      subtotal  = subtotal + ($(element).val() * $(element).data("price"));

      if($(element).data("size"))
      {
        size  = $(element).data("size").replace('m', '');
        if($(element).data("frontier"))
        {
          area  = area + (size * $(element).val()) / (1/0.149);
        }else
        {
          area  = area + (size * $(element).val()) / (1/0.0982);
        }
      }
    });

    subtotal  = (subtotal/100).toFixed(2);
    $('.subtotal' + id).html(subtotal);
    if(size != 2.2)
    {
      suggestAccessories(id, area, quantityElement);
    }
  }

  function suggestAccessories(id, area, quantityElement)
  {
    $.each($('#add' + id + ' .accessories .value'), function(index, element){

      if($(element).data("ratio") !== undefined)
      {
        if($.isNumeric($(element).data("ratio"))){
          var ratio = $(element).data("ratio")

          $(element).html(Math.ceil(quantityElement.val() * ratio));
        }else{
          $(element).html(0);
          $(element).parent('.accessoryrecommended').css({ display: 'none' });
        }

      }else{
        if($(element).data("tag") == 'Starter Clips')
        {
          amount  = Math.round(area/suggestions[$(element).data("tag")]);
          amount  = amount == 0 ? 1 : amount;
          $(element).html(amount);
        }else
        {
          if($(element).data("tag") == 'Fascia' || $(element).data("tag") == 'L Trim' || $(element).data("tag") == 'Batten' || $(element).data("tag") == '50x50')
          {
            $(element).html(Math.ceil(quantityElement.val()*suggestions[$(element).data("tag")]));
          }else
          {
            $(element).html(Math.ceil(area/suggestions[$(element).data("tag")]));
          }
        }
      }
    });
  }

  function resetValues(){
    console.log('resetting values');
    var id        = $('.subtotal .itemaddtocart').data("form");
    var productid   = $('.subtotal .itemaddtocart').data("productid");
    Shopify.queue     = [];
    $('#' + id + ' .qty').each(function() {
      $(this).val('0');
    });
  }

  function cartSuccess()
  {
    console.log('cart success');
    cartData  = getCart();
    $('.cartitemscount').html(cartData.item_count);
    if(cartData.item_count)
    {
      $('#cart-target,.menu-icon.lower .cartitemscount').addClass('hasitems');
    }else
    {
      $('#cart-target,.menu-icon.lower .cartitemscount').removeClass('hasitems');
    }
    //swal({   title: "Added to cart",   text: "I will close in 2 seconds.",   timer: 2000,   showConfirmButton: false });
    swal({title:"Added to cart", text:"", type: "success",   timer: 2000,   showConfirmButton: false});
    resetValues();
  }

  $('a.cart, .cart-close').click(function(e){
    if($('.cart-side').length)
    {
      e.preventDefault();
      toggleCart();
    }
  });

  $('.calc-slide-close').click(function(e){
    if($('.calculator-side').length)
    {
      e.preventDefault();
      toggleCalulatorEmailPanel();
    }
  });

  $('img.colourchooser').click(function(){
  //console.log($(this).data('url'));
  });

  $('.tabadd').click(function(){
    $('.contentadd').hide();
    $('.tabadd.selected').removeClass('selected');
    $(this).addClass('selected');
    id = $(this).data('id');
    $('#add' + id).show();
    $('#add' + id).offset({ top: $('.btnadd' + id).offset().top + $('.btnadd' + id).height()});
  });

  $('.itemminus').click(function(){
    location.href="/cart/change?line=" + $(this).data("line") + "&quantity=" + (parseInt($(this).data("quantity")) - 1) + '#cart';
  });

  $('.itemadd').click(function(){
    location.href="/cart/change?line=" + $(this).data("line") + "&quantity=" + (parseInt($(this).data("quantity")) + 1) + '#cart';
  });
  /*
    cartData  = getCart();

    $.each($('.qty'), function(index, element){
      $.each(cartData.items, function(cartIndex, cartItem){
        if(cartItem.id == $(element).data("id"))
        {
          $(element).val(cartItem.quantity);
        }
      });
    });
    console.log(cartData);
    */
  $('.productprice').each(function(index, element){

    ppm = $(this).data("price")/String($(this).data("size")).replace('m', '');

    if($(this).data("price") != '0.00') {

      if(($(this).data("type") == 'Decking' || $(this).data("type") == 'Fascia' || $(this).data("type") == 'Bullnose' || $(this).data("type") == 'L Trim' || $(this).data("type") == 'Edge Board' || $(this).data("type") == 'Joist' || $(this).data("type") == 'Sentinel fascia' || $(this).data("type") == 'Sentinel L Trim' || $(this).data("type") == 'Sentinel')) {

        $(this).html("&pound;" + numberWithCommas(ppm.toFixed(2)));
        $id   = $(this).data("id");
        exvat = (parseFloat(ppm) * 100)/120;
        $('#exvat' + $id).html("&pound;" + numberWithCommas(exvat.toFixed(2)));

      } else if($(this).data("type") == 'Fencing') {

        price = parseFloat($(this).data("price"));
        $(this).html("&pound;" + numberWithCommas(price.toFixed(2)));
        $id   = $(this).data("id");
        exvat = (parseFloat(price) * 100)/120;
        $('#exvat' + $id).html("&pound;" + numberWithCommas(exvat.toFixed(2)));

      } else {

        if($(this).data("type") == 'Cladding') {

          $(this).html("&pound;" + numberWithCommas(ppm.toFixed(2)));
          $id   = $(this).data("id");
          exvat = (parseFloat(ppm) * 100)/120;
          $('#exvat' + $id).html("&pound;" + numberWithCommas(exvat.toFixed(2)));

        } else {

          if($(this).data("type") == 'Sentinel') {

            $(this).html("&pound;" + numberWithCommas(ppm.toFixed(2)));
            $id   = $(this).data("id");
            exvat = (parseFloat(ppm) * 100)/120;
            $('#exvat' + $id).html("&pound;" + numberWithCommas(exvat.toFixed(2)));

          } else if($(this).data("lvt") == 'lvt-flooring') {

            $(this).html("&pound;" + numberWithCommas($(this).data("price")));
            $('#perunit' + $(this).data("id")).html(' per length');
            $id   = $(this).data("id");
            exvat = (parseFloat($(this).data("price")) * 100)/120;
            $('#exvat' + $id).html("&pound;" + numberWithCommas(exvat.toFixed(2)));

          } else {

            $(this).html("&pound;" + numberWithCommas($(this).data("price")));
            $('#perunit' + $(this).data("id")).html('PER ' + $(this).data("size"));
            $id   = $(this).data("id");
            exvat = (parseFloat($(this).data("price")) * 100)/120;
            $('#exvat' + $id).html("&pound;" + numberWithCommas(exvat.toFixed(2)));

          }

        }
      }

    } else {

        id  = $(this).data("id");
        $(this).html('FREE');
        $(this).parent().children('.vatcontainer').hide();
        $('#add' + id + ' .contentaddcontainer.variants').hide();
        $('#add' + id + ' .contentaddcontainer.accessories').hide();
        $('#add' + id + ' .qty').val(1);

    }

  });

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  $('.accessoryprice').each(function(index, element){
    if($(this).data("size") != 'Default Title')
    {
      ppm = $(this).data("price")/String($(this).data("size")).replace('m', '');
      if($(this).data("price") != '0.00')
      {
        if(($(this).data("type") == 'Cladding' || $(this).data("type") == 'Fascia' || $(this).data("type") == 'Bullnose' || $(this).data("type") == 'L Trim' || $(this).data("type") == 'Edge Board' || $(this).data("type") == 'Sentinel fascia' || $(this).data("type") == 'Sentinel L Trim' || $(this).data("type") == 'Sentinel' || $(this).data("type") == 'Joist') && !$(this).data("issample"))
        {
          $(this).html("&pound;" + numberWithCommas(ppm.toFixed(2)));
          $id   = $(this).data("id");
          exvat = (parseFloat(ppm) * 100)/120;
          $('#exvat' + $id).html("&pound;" + numberWithCommas(exvat.toFixed(2)));
        }else{
          $(this).html("&pound;" + numberWithCommas($(this).data("price")));
          /*$('#perunit' + $(this).data("id")).html('PER ' + $(this).data("size"));*/
          if($(this).data("type") == 'Support'){
              $('#perunit' + $(this).data("id")).html('FROM ' + $(this).data("size"));
          } else if($(this).data("lvt") == 'lvt-flooring') {
              $('#perunit' + $(this).data("id")).html(' per length');
          }else{
              $('#perunit' + $(this).data("id")).html('PER ' + $(this).data("size"));
          }
          $id   = $(this).data("id");
          exvat = (parseFloat($(this).data("price")) * 100)/120;
          $('#exvat' + $id).html("&pound;" + numberWithCommas(exvat.toFixed(2)));
        }
      }
    }else
    {
        price = parseFloat($(this).data("price"));
        $(this).html("&pound;" + numberWithCommas(price.toFixed(2)));
        $id   = $(this).data("id");
        exvat = (parseFloat(price) * 100)/120;
        $('#exvat' + $id).html("&pound;" + numberWithCommas(exvat.toFixed(2)));
    }
  });

  $('.qty').keyup(function(){
    var qty     = parseInt($(this).val());
    var inventory = parseInt($(this).data("inventory"));

    /*if(qty > inventory)
    {
        callToAction();
    }*/
    var productid   = $(this).data("productid");
    var id        = $(this).data("id");
    var qElement    = $(".quantity" + id);

    if (!$(this).hasClass('js-Ignore')) {
      updateSubtotal(productid, qElement);
    };
  });



  $('.add').click(function(){
    console.log('Plus icon success')
    var id = $(this).attr("data-id");
    var productid   = $(this).attr("data-productid");
    var price     = $(this).attr("data-price");
    var quantityElement = $("#add" + productid + " .quantity" + id);
    console.log(quantityElement);
    var qElement    = $(".quantity" + id);

    qElement.val(parseInt(qElement.val()) + 1);

    var qty     = parseInt(quantityElement.val());
    var inventory = parseInt(quantityElement.data("inventory"));

    /*if(qty > inventory)
    {
        callToAction();
    }*/

    //console.log(parseInt(quantityElement.val()), parseInt(quantityElement.data("inventory")));
    if (!$(this).hasClass('js-Ignore')) {
      updateSubtotal(productid, qElement);
    };
  });

  $('.minus').click(function(){
    console.log('Minus icon success');
    var id        = $(this).attr("data-id");
    var productid   = $(this).attr("data-productid");
    var price     = $(this).attr("data-price");
    var quantityElement = $("#add" + productid + " .quantity" + id);
    var qElement    = $(".quantity" + id);

    if(parseInt(qElement.val()) > 0)
    {
      qElement.val(parseInt(qElement.val()) - 1);
    }

    var qty     = parseInt(quantityElement.val());
    var inventory = parseInt(quantityElement.data("inventory"));

    /*if(qty > inventory)
    {
        callToAction();
    }*/

    //console.log(parseInt(quantityElement.val()), parseInt(quantityElement.data("inventory")));
    if (!$(this).hasClass('js-Ignore')) {
      updateSubtotal(productid, qElement);
    };
  });

  $('.minus-minimum-qty').click(function(){
    //console.log('qty -');
    var id        = $(this).attr("data-id");
    var productid   = $(this).attr("data-productid");
    var price     = $(this).attr("data-price");
    var quantityElement = $("#add" + productid + " .quantity" + id);
    var qElement    = $(".quantity" + id);

    var min = quantityElement.attr("min");

    if(min.length && Number.isInteger(parseInt(min))){
      min = parseInt(min);
    }else{
      min = 1;
    }

    if(parseInt(qElement.val()) > min)
    {
      qElement.val(parseInt(qElement.val()) - 1);
    }

    var qty     = parseInt(quantityElement.val());
    var inventory = parseInt(quantityElement.data("inventory"));

    updateSubtotal(productid, qElement);
  });


  $('.offcanvas-backdrop').click(function () {
    console.log('clicked backdrop');
    toggleCart();
  });

  $('.offcanvas-backdrop-calc').click(function () {
    console.log('clicked backdrop');
    toggleCalulatorEmailPanel();
  });

  function toggleCart()
  {
    $('.cart-side').toggleClass('close');
    $('.offcanvas-backdrop').toggleClass('shown');
    cartShown = !$('.cart-side').hasClass('close');
  $('.cartitemscount').html(CartJS.cart.item_count);
    if(!CartJS.cart.item_count)
    {
      $('#cart-target,.menu-icon.lower .cartitemscount').removeClass('hasitems');
    }else
    {
      $('#cart-target,.menu-icon.lower .cartitemscount').addClass('hasitems');
    }
  }

  var currentCalculator = '';

  function toggleCalulatorEmailPanel()
  {
    $('.calculator-side').toggleClass('close');
    $('.offcanvas-backdrop-calc').toggleClass('shown');

    if($('.offcanvas-backdrop-calc').hasClass('shown'))
    {
      $('#calcform').fadeIn(0);
      $('#calcemailresult').fadeOut(0);
    }
  }

  function getCalculatorData(currentCalculator)
  {

    calcData = {items:[], shipping:0, total:0, referrer: 'uk', name:$('#calcname').val(), email:$('#calcemail').val(), contactnumber:$('#calccontactnumber').val()};
    $.each($('#' + currentCalculator + ' .calcresultrow'), function(index, element){
      if($(element).find('.productimage img').length)
      {
        img     = $(element).find('.productimage img').prop('src');
        label     = $(element).find('.productlabel').text();
        quantity  = $(element).find('.productquantity .qty').val();
        price     = $(element).find('.productprice').text();
        calcData.items.push({img:img, label:label, quantity:quantity, price:price});
      }
    });
    calcData.shipping   = $('#' + currentCalculator + ' #shippingprice').text();
    calcData.total    = $('#' + currentCalculator + ' #vatprice').text();

    sendCalculatorData(calcData);
  }

  function sendCalculatorData(data)
  {
    $.ajax({
      //https://hyperioncomposites.com/calculators/emailcalculator.php
      url: 'https://www.hyperioncomposites.com/calculators/emailcalculator.php',
      type: 'post',
      dataType: 'json',
      success: function (data) {
        console.log('here');
        $('#calcform').fadeOut('slow', function(){
          $('#calcemailresult').html(data.msg).fadeIn('slow');
        });
      },
      data: data
    });

  }

  $('#calcemailsubmit').click(function(){
    getCalculatorData(currentCalculator);
  });

  $('.calcsendemail').click(function(){
    currentCalculator = $(this).data('calculator');
    toggleCalulatorEmailPanel();
  });

  $('.subtotal .itemaddtocart').click(function(){
    var id = $(this).attr("data-form");
    var variantId = id.match(/\d+/)[0];
    var productid = $(this).attr("data-productid");
    Shopify.queue = [];
    var productselected = false;
    console.log(variantId);

    $('.quantity' + variantId).each(function() {
      console.log(this);
      if(parseInt($(this).val(), 10) > 0){
        productselected = true;
        var length = $(this).attr('data-length') || 0
        CartJS.addItem($(this).attr('data-id'), $(this).val(), { length: length }, {

        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
          if(!cartShown) {
            if(!window.location.pathname.includes("products")){
              toggleCart();
              cartShown = true;
              console.log(data );
            }
          }
        },

        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            $('#message').addClass('message-error');
            $('#message').html('There was a problem adding to the cart!');
        }});
      }
    });
  });

  $('.sp-Sample_Button').click(function(){
    var id = $(this).data("form");
    var productid = $(this).data("productid");
    Shopify.queue = [];
    var productselected = true;

    var length = $(this).data('length') || 0
    CartJS.addItem($(this).data('id'), $(this).val(), { length: length }, {
      "success": function(data, textStatus, jqXHR) {
          if(!cartShown)
          {
            toggleCart();
            cartShown = true;
            console.log(data );
          }
      },
      "error": function(jqXHR, textStatus, errorThrown) {
          $('#message').addClass('message-error');
          $('#message').html('There was a problem adding to the cart!');
    }});
  });

  $('.prd-Sample_Button').click(function(){
    var id        = $(this).data("form");
    var productid   = $(this).data("productid");
    Shopify.queue     = [];
    var productselected = true;

    var length = $(this).data('length') || 0
    CartJS.addItem($(this).data('id'), $(this).val(), { length: length }, {
      "success": function(data, textStatus, jqXHR) {
          if(!cartShown)
          {
            toggleCart();
            cartShown = true;
            console.log(data );
          }
      },
      "error": function(jqXHR, textStatus, errorThrown) {
          $('#message').addClass('message-error');
          $('#message').html('There was a problem adding to the cart!');
    }});
  });

  $('.samplebuy').click(function(){
    var id        = $(this).data("form");
    var productid   = $(this).data("productid");
    Shopify.queue     = [];
    var productselected = false;

    $('#' + id + ' .qtysmaple').each(function() {
      if(parseInt($(this).val(), 10) > 0){
        productselected = true;
        var length = $(this).data('length') || 0
        CartJS.addItem($(this).data('id'), $(this).val(), { length: length }, {

            // Define a success callback to display a success message.
            "success": function(data, textStatus, jqXHR) {
                if(!cartShown)
                {
                  toggleCart();
                  cartShown = true;
                  console.log(data );
                }
            },

            // Define an error callback to display an error message.
            "error": function(jqXHR, textStatus, errorThrown) {
                $('#message').addClass('message-error');
                $('#message').html('There was a problem adding to the cart!');
            }});
      }
    });
  });

  $.each(jQuery('.perm'), function(index, element){
    price = $(this).data("price");
    if(price != '0.00')
    {
        $id   = $(this).data("id");
        exvat = (parseFloat(price) * 100)/120;
        $('#exvat' + $id).html("&pound;" + exvat.toFixed(2));
    }
  });

  $.each(jQuery('.pricepersquaremetre'), function(index, element){

    price = $(this).data("price");
    size  = String($(this).data("size")).replace('m', '');
    ppm   = price/size;

    /* Convert length x width variants into a number */
    var lxwSize = String($(this).data("size"));

        // for variants with more text instead of just two numbers
        if (lxwSize.indexOf("2 tiles (595x595mm)") >= 0) {
          var firstNumber = 600
          var secondNumber = 600
        } else if (lxwSize.indexOf("800x800mm tile") >= 0) {
        var firstNumber = 800
        var secondNumber = 800
        } else {
    var sizeSplit = lxwSize.split('x')
    console.log(sizeSplit)
    var firstNumber = sizeSplit[0]
    var secondNumber = sizeSplit[1]
        }
    var lxw = ((firstNumber*secondNumber) / 1000000)

    if($(element).data("frontier")) {
      sqmp  = (ppm * (1/0.1489992)).toFixed(2);
    } else if($(element).data("cladding")) {
      sqmp  = (ppm * (1/0.12004)).toFixed(2);
    } else if($(element).data("sentinel")) {
      sqmp  = (ppm * (1/0.14999)).toFixed(2);
    } else if($(element).data("tiles") && lxwSize == '600x600') {
      tmpSqmp = (1/lxw) * price
      sqmp  = (tmpSqmp/2).toFixed(2);
    } else if($(element).data("tiles") && lxwSize == '1200x400') {
      sqmp  = Math.ceil((((1/lxw) * price) + 0.01) * 100) / 100
    } else if($(element).data("tiles")) {
      sqmp  = Math.ceil((((1/lxw) * price) + 0.00001) * 100) / 100
    } else {
      sqmp  = (ppm * (1/0.151)).toFixed(2);
    }

    if($(this).data("price") != '0.00') {
      $(this).html("&pound;" + numberWithCommas(parseFloat(sqmp).toFixed(2)) + "</span>");
      $id   = $(this).data("id");
      exvat = (parseFloat(sqmp) * 100)/120;
      $('#exvat' + $id).html("&pound;" + numberWithCommas(exvat.toFixed(2)));
    }

  });

  Shopify.addCollectionPageItem = function(variantId, quantity, callback) {
    //console.log(variantId, quantity);
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {id: variantId, quantity: quantity},
      success: callback,
      error: Shopify.onError
    });
  }

  Shopify.moveAlong = function() {
    // If we still have requests in the queue, let's process the next one.
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift();
      Shopify.addCollectionPageItem(request.variantId, request.quantity, Shopify.moveAlong);
    }
    // If the queue is empty, we will redirect to the cart page.
    else {
      //document.location.href = '/cart';
      cartSuccess();
    }
  };

   Shopify.onSuccess = function() {

      var elem = $('.addtocart');

      elem.removeAttr("disabled");

      var quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1;

      $("html, body").animate({ scrollTop: 0 }, 250, 'swing');

      function animate() {

        $("#cart-animation").show();

        var addtocartWidth = elem.outerWidth() / 2
        var addtocartHeight = elem.outerHeight() / 2

        var addtocartLeft = elem.offset().left + addtocartWidth;
        var addtocartTop = $(elem).offset().top + addtocartHeight ;

        var buttonAreaWidth = $("#cart-target").outerWidth();
        var buttonAreaHeight = $("#cart-target").outerHeight();

        var buttonAreaLeft = ($("#cart-target").offset().left + buttonAreaWidth / 2  - $("#cart-animation").outerWidth() / 2) - 4 - 18;
        var buttonAreaTop = ($("#cart-target").offset().top + buttonAreaWidth / 2  - $("#cart-animation").outerHeight() / 2) - 4 - 8;

        var path = {
          start: {
            x: addtocartLeft,
            y: addtocartTop,
            angle: 190.012,
            length: 0.2
          },
          end: {
            x: buttonAreaLeft,
            y: buttonAreaTop,
            angle: 90.012,
            length: 0.50
          }
        };

        $('#cart-animation').text(quantity).animate(
        {
          path : new $.path.bezier(path)
        },
        1200,
        function() {
          $("#cart-animation").fadeOut(500, function() {
            $(elem).prop("disabled", false)
            var cartCount =  parseInt($('#cart-count').text()) + quantity;
            $('#cart-count').text(cartCount)
            $('#cart-target').addClass('has-items');
          })
        }
        );
      }

      animate();
    };

    Shopify.onError = function(XMLHttpRequest, textStatus) {
      // Shopify returns a description of the error in XMLHttpRequest.responseText.
      // It is JSON.
      // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      if (!!data.message) {
        alert(data.message + '(' + data.status  + '): ' + data.description);
      } else {
        alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
      }

      $('.addtocart').removeAttr("disabled");
    };

    Shopify.fullMessagesFromErrors = function(errors) {
      var fullMessages = [];
      jQuery.each(errors, function(attribute, messages) {
        jQuery.each(messages, function(index, message) {
          fullMessages.push(attribute + ' ' + message);
        });
      });
      return fullMessages;
    };

  //setSticky();
})

jQuery(window).load(function(){

  if ( $('.slides li').size() > 1 ) {

    $('.flexslider .slides').slick({
      infinite: true,
      lazyLoad: 'ondemand',
      fade: true,
      autoplay: true,
      autoplaySpeed: 10000,
      arrows: true,
      prevArrow: $('.flexslider-prev'),
      nextArrow: $('.flexslider-next')
    });
  }

  $("select.loc_on_change").change(function(){
    if($(this).attr("value") == "#") return false;
    window.location = $(this).attr("value");
  });


    function preload(arrayOfImages) {
      $(arrayOfImages).each(function (index, value) {
        //$('<img />').attr('src',this).appendTo('body').hide();
        (new Image()).src = value;
        //console.log(value);
      });
    }

    if($('.ourmission').length)
    {
      var arrayOfImages   = ['//cdn.shopify.com/s/files/1/0923/7934/t/1/assets/MissionPanelImg-Rollover.png','//cdn.shopify.com/s/files/1/0923/7934/t/1/assets/ProductsImg-Rollover.png','//cdn.shopify.com/s/files/1/0923/7934/t/1/assets/InspirationPanelImg-Rollover.png'];
      preload(arrayOfImages);
    }

});


var listData;

function emailListData() {
  $.ajax({
    type: "POST",
    url: '//webservice-ec.shoreprojects.com/envirobuild/emaillist.php',
    data: {listData:listData},
    dataType: 'json'
  });
}

/*============================*/
/* Update main product image. */
/*============================*/

var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).attr('src', newImageSrc);

  let productContainer = jQuery(mainImageDomEl).closest(".js-Product_Wrapper");
  let productType = $(productContainer).data('type');
  let productTag = $(productContainer).data('product-taglist');
  let isProductImagePopup = (productTag === "enable_image_popup" ? true : false);

  // console.log('productType is: ', productType);
  // console.log('productTag is: ', productTag);
  // console.log('isProductImagePopup is: ', isProductImagePopup);

  if( productType === 'Garden Furniture' || isProductImagePopup ){
    $(mainImageDomEl).parents('a').attr('href', newImageSrc);
  } else {
    if ($(window).width() > 782) {
      jQuery(mainImageDomEl).parent().trigger('zoom.destroy').zoom({
        url: newImageSrc.replace('_master', '')
      });
    }
  }
};

jQuery(document).ready(function($){

  // Product Images - Modal or Zoom
  if ($(".js-Product_Wrapper").data('type') == "Garden Furniture" || $(".js-Product_Wrapper").data('product-taglist') == 'enable_image_popup') {
    /* Enable modal window gallery */
    $(".js-Modal_Image").fancybox({
      padding:0,
      titleShow: false,
      overlayColor: '#000000',
      overlayOpacity: 0.2
    });

    $('.js-Modal_Image').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    });

  } else {

    /* Enable zoom */
    var mainProductImage = $('.prd-Product_FeaturedImage .rsp-Image_Image');
    if (mainProductImage.size()) {
      if ($(window).width() > 782) {
        var zoomSrc = $('.prd-Product_FeaturedImage').data('original-image');
        $(mainProductImage).parent().zoom( { url: zoomSrc } );
      }
    }

    /* Update main product image when a thumbnail is clicked and update zoom element */
    $('.js-Zoom_Image').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      $(mainProductImage).removeAttr('srcset')

      $('.prd-Product_Thumbnail').removeClass('active');
      $(this).parent().addClass('active');

      switchImage($(this).attr('href'), null, $(mainProductImage)[0]);
      return false;
    });
  }
  // End Product Images

  // Product Tabs
  $(".js-Accordion_Content").hide();
  $(".js-Accordion_Content:first").show();

  /* if in tab mode */
  $(".js-Accordion_Trigger").click(function() {

    $(".js-Accordion_Content").hide();
    var activeTab = $(this).attr("rel");
    $("#"+activeTab).fadeIn();

    $(".js-Accordion_Trigger").removeClass("active");
    $(this).addClass("active");

    $(".js-Accordion_Title").removeClass("d_active");
    $(".js-Accordion_Header[rel^='"+activeTab+"']").addClass("d_active");

  });

  /* if Accordion i.e. Mobile */
  $(".js-Accordion_Title").click(function() {

    $(".js-Accordion_Content").hide();
    var d_activeTab = $(this).attr("rel");
    $("#"+d_activeTab).fadeIn();

    $(".js-Accordion_Title").removeClass("d_active");
    $(this).addClass("d_active");

    $(".js-Accordion_Trigger").removeClass("active");
    $(".js-Accordion_Trigger[rel^='"+d_activeTab+"']").addClass("active");
  });
  // End Product Tabs

  $(".flyout").hide();

  $("#menu-toggle").on("click", function() {
    $(".flyout").slideToggle( "fast" );
  });

  $(".sub-menu").hide();
  $(".more").on("click", function() {
    $(this).nextAll("ul").slideToggle( "fast" );
    $("i", this).toggleClass("fa-plus fa-minus");
  });

  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })

  $("li.dropdown").hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });

}); // end document ready

/* jQuery css bezier animation support -- Jonah Fox */

;(function($){

  $.path = {};

  var V = {
    rotate: function(p, degrees) {
      var radians = degrees * Math.PI / 180,
        c = Math.cos(radians),
        s = Math.sin(radians);
      return [c*p[0] - s*p[1], s*p[0] + c*p[1]];
    },
    scale: function(p, n) {
      return [n*p[0], n*p[1]];
    },
    add: function(a, b) {
      return [a[0]+b[0], a[1]+b[1]];
    },
    minus: function(a, b) {
      return [a[0]-b[0], a[1]-b[1]];
    }
  };

  $.path.bezier = function( params, rotate ) {
    params.start = $.extend( {angle: 0, length: 0.3333}, params.start );
    params.end = $.extend( {angle: 0, length: 0.3333}, params.end );

    this.p1 = [params.start.x, params.start.y];
    this.p4 = [params.end.x, params.end.y];

    var v14 = V.minus( this.p4, this.p1 ),
      v12 = V.scale( v14, params.start.length ),
      v41 = V.scale( v14, -1 ),
      v43 = V.scale( v41, params.end.length );

    v12 = V.rotate( v12, params.start.angle );
    this.p2 = V.add( this.p1, v12 );

    v43 = V.rotate(v43, params.end.angle );
    this.p3 = V.add( this.p4, v43 );

    this.f1 = function(t) { return (t*t*t); };
    this.f2 = function(t) { return (3*t*t*(1-t)); };
    this.f3 = function(t) { return (3*t*(1-t)*(1-t)); };
    this.f4 = function(t) { return ((1-t)*(1-t)*(1-t)); };

    /* p from 0 to 1 */
    this.css = function(p) {
      var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4=this.f4(p), css = {};
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( this.p1[0]*f1 + this.p2[0]*f2 +this.p3[0]*f3 + this.p4[0]*f4 +.5 )|0;
      css.y = this.y = ( this.p1[1]*f1 + this.p2[1]*f2 +this.p3[1]*f3 + this.p4[1]*f4 +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };

  $.path.arc = function(params, rotate) {
    for ( var i in params ) {
      this[i] = params[i];
    }

    this.dir = this.dir || 1;

    while ( this.start > this.end && this.dir > 0 ) {
      this.start -= 360;
    }

    while ( this.start < this.end && this.dir < 0 ) {
      this.start += 360;
    }

    this.css = function(p) {
      var a = ( this.start * (p ) + this.end * (1-(p )) ) * Math.PI / 180,
        css = {};

      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( Math.sin(a) * this.radius + this.center[0] +.5 )|0;
      css.y = this.y = ( Math.cos(a) * this.radius + this.center[1] +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };

  $.fx.step.path = function(fx) {
    var css = fx.end.css( 1 - fx.pos );
    if ( css.prevX != null ) {
      $.cssHooks.transform.set( fx.elem, "rotate(" + Math.atan2(css.prevY - css.y, css.prevX - css.x) + ")" );
    }
    fx.elem.style.top = css.top;
    fx.elem.style.left = css.left;
  };



})(jQuery);


// BAO Edits
$( document ).ready(function() {
  $('.toggle-sample').click(function(){
    $('.form-contents').toggleClass('open-toggle');
    return false;
  })

  /* Cookie Policy */
  $('.cookie-policy .close').click(function(e){
      e.preventDefault();
      $('.cookie-policy').addClass('cookie-policy-hide');
      $('.cookie-policy').hide();
      Cookies.set('cookie-policy', 'true', { expires: 3650 });
  });

  if(Cookies !== undefined && Cookies.get('cookie-policy') === undefined  ){
      $('.cookie-policy').show();
  } else {
      $('.cookie-policy').hide();
  }

  // Open all links not on same domain in new tab
  $('a:not([data-href])').each(function() {
    var a = new RegExp('/' + window.location.host + '/');
    if(!a.test(this.href)) {
      $(this).click(function(event) {
        event.preventDefault();
        event.stopPropagation();
        window.open(this.href, '_blank');
      }
      );
    }
  });


  $('.scrollto, .scroll').click(function() {
    var elementClicked = $(this).attr("href");
    var destination = $(elementClicked).offset().top;
    $("html:not(:animated),body:not(:animated)").animate({ scrollTop: destination}, 800 );
    return false;
  });

  if ( $( ".vertical-center-4" ).length ) {
    $(".vertical-center-4").slick({
       centerMode: true,
       slidesToShow: 4,
       slidesToScroll: 3,
       autoplay: true
     });
   }

  if ( $( ".rte.carousel .grid" ).length ) {
    $('.carousel.rte .grid').slick({
      infinite: true,
      lazyLoad: 'ondemand',
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: false,
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false
          }
        }
      ]
    })
    setTimeout(() => {
    $( ".art-featuredArticle_Content.carousel .slick-track" ).css("display", "flex")
    }, 10)
  }

  if ( $( ".text-carousel .grid" ).length ) {
    $('.text-carousel .grid').slick({
      infinite: true,
      centerMode: true,
      adaptiveHeight: true,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerPadding: '0px'
          }
        }
      ]
    });
  }

  if ( $( ".usps .grid" ).length ) {
    $('.usps .grid').slick({
      mobileFirst: true,
      infinite: true,
      centerMode: true,
      adaptiveHeight: true,
      dots: true,
      arrows: false,
      centerPadding: '0px',
      responsive: [
        {
          breakpoint: 768,
          settings: 'unslick'
        }
      ]
    });
  }

  if ( $( ".sec-Grid_Container-mobile" ).length ) {
    $('.sec-Grid_Container-mobile').slick({
      mobileFirst: true,
      dots: true,
      infinite: false,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: 'unslick'
        }
      ]
    });
  }

  // mobile nav controls
  $(".mob-menu-btn").on("click", function (e) {
    $(".mob-nav-panel").addClass("nav-open");

  });
  $(".subnav-close-btn").on("click", function () {
    $(".mob-nav-panel").removeClass("nav-open");

  });

  $(".has-sub-nav").on("click", function (e) {
    if ($(window).width() < 800) {
      e.preventDefault();
      $(this).siblings(".dropdownlarge").addClass("subnav-open");
    };
  });
  $(".subnav-back-btn").on("click", function () {
    $(this).parents(".dropdownlarge").removeClass("subnav-open");
  });
  $(".scrollto:not(.has-sub-nav)").on("click", function () {
    $(this).parents(".dropdownlarge").removeClass("subnav-open");
    $(".mob-nav-panel").removeClass("nav-open");
  });
  $('.subnav-close-btn.large-hide.firstLevel, .mob-nav.flex.justify-between').on("click", function (){
    $('.onClickClose').hide();
  });

  //FAQ section accordian
  var acc = document.getElementsByClassName("faq-question");
  var faqcount;

  for (faqcount = 0; faqcount < acc.length; faqcount++) {
      acc[faqcount].addEventListener("click", function() {
          this.classList.toggle("faq-active");

          var panel = this.nextElementSibling;
          if (panel.style.maxHeight){
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
      });
  }

});

/* FAQ Page */
$(function(){
  $('.faq-List_Title').click(function(){
    $(this).toggleClass('faq-List_Title-active');
    $('.faq-List_Questions[data-category='+$(this).data("handle")+']').toggleClass('faq-List_Questions-active');
  });

  //$('.faq-Question_Title').click(function(){
  //  $(this).parent().toggleClass('faq-Question-open');
  //});
});

/* Modal - Garden Furniture Only */
const cookieName = 'envirobuild-newsletter-modal'
const modalHasBeenShown = false
const shouldShowNewsletterModal = Cookies.get(cookieName) === undefined

const showNewsletterModal = () => {
  window.setTimeout(() => {
    const modalHasBeenShown = true
    const newsletterModal = document.querySelector(".mod-Modal-garden")

    Cookies.set(cookieName, 'true', {
      expires: 365
    })

    newsletterModal.classList.add('mod-Modal-active')
    const close = document.querySelector('[data-modal-close]')
    close.addEventListener(
      'click',
      () => {
        newsletterModal.classList.remove('mod-Modal-active')
      },
      2000
    )
  }, 3000)
}

if (shouldShowNewsletterModal) {
  showNewsletterModal()
}

function initSlider(slider) {
  // Initialise Slick
  let leftArrow = '<div class="slick-carousel__arrow slick-carousel__arrow--left"> <?xml version="1.0" encoding="iso-8859-1"?><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><path d="M367.954,213.588L160.67,5.872c-7.804-7.819-20.467-7.831-28.284-0.029c-7.819,7.802-7.832,20.465-0.03,28.284l207.299,207.731c7.798,7.798,7.798,20.486-0.015,28.299L132.356,477.873c-7.802,7.819-7.789,20.482,0.03,28.284c3.903,3.896,9.016,5.843,14.127,5.843c5.125,0,10.25-1.958,14.157-5.873l207.269-207.701C391.333,275.032,391.333,236.967,367.954,213.588z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>';
  let rightArrow = '<div class="slick-carousel__arrow slick-carousel__arrow--right"> <?xml version="1.0" encoding="iso-8859-1"?><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><path d="M367.954,213.588L160.67,5.872c-7.804-7.819-20.467-7.831-28.284-0.029c-7.819,7.802-7.832,20.465-0.03,28.284l207.299,207.731c7.798,7.798,7.798,20.486-0.015,28.299L132.356,477.873c-7.802,7.819-7.789,20.482,0.03,28.284c3.903,3.896,9.016,5.843,14.127,5.843c5.125,0,10.25-1.958,14.157-5.873l207.269-207.701C391.333,275.032,391.333,236.967,367.954,213.588z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>';

  var isInViewport = function (elem) {
    if(elem) {
      var bounding = elem.getBoundingClientRect();
      return (
          bounding.left >= 0 &&
          bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }
    return true
  }

  function elementInViewportHorizontally(el) {
    return (
      el.getBoundingClientRect().left > 0 &&
      el.getBoundingClientRect().right < window.innerWidth
    )
  }

   function slickWithPadding(event, slick, currentSlide, alternative=false) {
    if(isInViewport(slick.$slides[slick.$slides.length - 1])) {
      $(slick.$nextArrow).addClass('slick-disabled') 
    } else {
      $(slick.$nextArrow).removeClass('slick-disabled') 
    }
  }

  function updateOpacity(slick, infinite, currentSlide) {
    setTimeout(function() {
      if(window.innerWidth > 640) {
        slick.$slider.find('.slick-slide').each(function () {
          if(elementInViewportHorizontally(this)) {
            $(this).removeClass('opacity-lower');
          } else {
            $(this).addClass('opacity-lower');
          }
        })
      }
    }, 100)
  }

  const settings = $(slider).attr('data-slider-settings') ? JSON.parse($(slider).attr('data-slider-settings')) : {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  }

  if($(slider).attr('data-standard-arrows')) {      
    settings['prevArrow'] = leftArrow;
    settings['nextArrow'] = rightArrow;
  }

  function highlightSlide(slider) {
    $(slider).find('.col-card').each(function(card) {
      let highlights = $(this).find('.col-card__highlight-text');
      if(highlights[0] && highlights[1]) {
        $(highlights[0]).animate({left: '-100px'}, 200, function() {
          $(highlights[0]).css('left', '100%');
          $(highlights[0]).insertAfter($(highlights[highlights.length - 1]));
        });
        $(highlights[1]).animate({left: '30px'});
      }
    })
  }

  if($(slider).attr('data-highlights')) {
    $(slider).find('.col-card__highlight').each(function(i, highlight) {
      if($(highlight).find('.col-card__highlight-text').length > 0) {
        $(highlight).removeClass('col-card__highlight-inner--hide')
      }
    });
    setInterval(function() {highlightSlide(slider) }, 5000);
  }

  // If has starting padding
    $(slider).on('afterChange', function(event, slick, currentSlide) { 
      if($(slider).attr('data-with-padding')) { slickWithPadding(event, slick, currentSlide) }
      if(!$(slider).attr('data-disable-opacity')) { updateOpacity(slick) }
    });
    $(slider).on('init', function(event, slick, currentSlide) { 
      if($(slider).attr('data-with-padding')) { slickWithPadding(event, slick, currentSlide) }
      if(!$(slider).attr('data-disable-opacity')) { updateOpacity(slick) }
    });

  $(slider).slick(settings);
}

// What's In Our Products Pie Chart
function initPie() {
  const $allProducts = $('.impact-product-loop');
  const $allPies = $('.impact-pie-target');

  $allProducts.on('click', function(x) {
    if(!$(this).hasClass('impact-loop__product--selected')) {
      const pieTarget = $(this).attr('data-pie-target');

      $allProducts.removeClass('impact-loop__product--selected');
      $(this).addClass('impact-loop__product--selected');
      $allPies.addClass('impact-pie__container--hide')
      $(pieTarget).removeClass('impact-pie__container--hide')
    }
  })
}

/* Mobile search box */
$(document).ready(function(){

  initPie()

  $('.mob-search-link').click(function(){
    $('.hd-Search').addClass('hd-Search-mobOpen');
  });

  $('.hd-Search_MobileClose').click(function(){
    $('.hd-Search').removeClass('hd-Search-mobOpen');
  });

    // Now needs to be on all devices
    $('.slickMobile.hd-Usps_Items').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: false,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              centerMode: false
          }
        },
        {
          breakpoint: 1274,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: true
          }
        },
        {
          breakpoint: 1024,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: false
          }
        },
        {
          breakpoint: 600,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true
          }
        }
      ]
    });
    


  $('.slick-carousel').each(function() {
    if(!$(this).attr('data-disable')) {
      initSlider(this)
    }
  });

  // Enable expand section
  $('[data-expand]').each(function() {
    $(this).on('click', function() {
      let selector = $(this).attr('data-expand');
      let $selectorTarget = $(selector);
      if($selectorTarget) {
        $selectorTarget.toggleClass('col-expand--open');
        let carousel = $selectorTarget.find('[data-disable]');
        if(carousel) {
          $(carousel).removeAttr('data-disable');
          initSlider(carousel);
        }
      }

    })
  })

  // Menu
  const $menu = $('#col-menu');
  $('#col-menu-selector').on('click', function() {
    $menu.toggleClass('col-menu-open')
  })

});


function initClerkSlider(data) {
  const customSlider = $('#clerk-custom-slider');
  if(customSlider) {
    initSlider($('#clerk-custom-slider'))
  }
}


